module.exports = __webpack_public_path__ + "static/media/orszagos_dohanyboltellato.3a5d8b2f.png";